import React from 'react';

import classes from './Footer.module.css';

export default class Footer extends React.Component {
  render () {
    return (<footer className={classes.Footer}>{this.props.children}</footer>)
  }
}